export class QueryString {
    private static instance: QueryString;

    private params: Record<string, string>;

    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() {
        const qs = window.location.search.split('+').join(' ');
        this.params = {};
        let tokens;
        const re = /[?&]?([^=]+)=([^&]*)/g;
        while ((tokens = re.exec(qs)) !== null) {
            this.params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        }
    }

    public static GetInstance(): QueryString {
        if (!QueryString.instance) {
            QueryString.instance = new QueryString();
        }

        return QueryString.instance;
    }

    private commit() {
        const url = `${window.location.pathname}${Object.keys(this.params).length ? '?' + new URLSearchParams(this.params).toString() : ''}${window.location.hash}`;
        window.history.replaceState({ 'path': url }, '', url);
    }

    public Get(key: string): string | undefined {
        return this.params[key];
    }

    public Set(key: string, value: string) {
        this.params[key] = value;
        this.commit();
    }

    public Delete(key: string) {
        delete this.params[key];
        this.commit();
    }
}

export const G = () => QueryString.GetInstance();